import { createStore, combineReducers, applyMiddleware } from 'redux'

import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'

import authReducer from 'common/redux/auth'
import rootReducer from 'common/redux/root'
import assignmentReducer from 'broker/redux/assignment'
import accountReducer from 'broker/redux/account'
import inquiryModalReducer from 'broker/redux/inquiry_modal'
import manageUsersReducer from 'broker/redux/manage_users'
import envConfigReducer from 'broker/redux/env_config'
import brokerPerformanceReducer from 'broker/redux/broker_performance'
import brokerOpportunitiesReducer from 'broker/redux/broker_opportunities'
import brokerCoverageReducer from 'broker/redux/broker_coverage'
import deepRouteReducer from 'broker/redux/deep_route'
import { analyticsMiddleware, analyticsReducer} from 'broker/analytics'

import { reducer as modalReducer } from 'redux-modal'

import { routerReducer } from 'react-router-redux'
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';

import { notifyErrorMiddleware } from 'common/middleware/error'
import loaderMiddleware from 'common/middleware/loader'

const logger = createLogger()
const router = routerMiddleware(browserHistory)

const initialState = {
  auth: {
    user: window.OD.initialState.user
  },
  envConfig: window.OD.initialState.env_config,
  deepRoute: window.OD.initialState.deep_route
}

export default () => (
    createStore(
      combineReducers({
        root: rootReducer,
        auth: authReducer,
        routing: routerReducer,
        modal: modalReducer,
        assignment: assignmentReducer,
        account: accountReducer,
        inquiryModal: inquiryModalReducer,
        manage_users: manageUsersReducer,
        analytics: analyticsReducer,
        envConfig: envConfigReducer,
        broker_performance: brokerPerformanceReducer,
        broker_opportunities: brokerOpportunitiesReducer,
        broker_coverage: brokerCoverageReducer,
        deepRoute: deepRouteReducer
      }),
      initialState,
      applyMiddleware(router, thunk, logger, notifyErrorMiddleware, loaderMiddleware, analyticsMiddleware),
    )
)
